import ScrollToTop from "./components/ScrollToTop";

import React from "react";
// import { OpenSans } from '@fontsource/open-sans'; // Import the Open Sans font
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/header";
import Footer from "./components/Footer/footer"; // Import Footer
import Home from "./components/screens/Home/home";
import ContactUs from "./components/screens/ContactUs/contactus";
import "./navigation.css";
// import WhatsAppChatbot from './components/screens/whatsapp/whatsapp';
import BookConsultation from "./components/screens/BookConsultation/bookconsultation";
import Loginhcura from "./components/screens/Loginhcura/Loginhcura";
import Aboutus from "./components/screens/Aboutus/aboutus";
import Online from "./components/screens/Online/online";
import Corporates from "./components/screens/Corporates/corporates";
import Doctors from "./components/screens/Doctors/doctors";
// import SkinTreatment from './components/screens/Skintreatments/skintreatments';
import Bangalore from "./components/screens/OurClinics/Bangalore";
import Chennai from "./components/screens/OurClinics/Chennai";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PrivacyPolicy from "./components/screens/privacyPolicy/Privacypolicy";
import Disclaimer from "./components/screens/Disclaimer/disclaimer";
import TermsConditions from "./components/screens/TermsAndConditions/terms";
import Treatments from "./components/screens/Treatments/treatments";
// import Skin1 from './components/screens/Treatments/Skintreatment/Skin1';
import Bangalorejay from "./components/screens/OurClinics/bangalorejay";
import ChennaiMadh from "./components/screens/OurClinics/chennaiMadh";
import ChennaiVal from "./components/screens/OurClinics/chennaiVal";
import TambaramClinic from "./components/screens/OurClinics/Westtambaram";
import HCuraNavalur from "./components/screens/OurClinics/navalur";
import PondyBranch from "./components/screens/OurClinics/Pondy";
// import Diabetes from './components/screens/Treatments/Hormonaltreatments/diabetes';
// import Asthma from './components/screens/Treatments/Respiratorytreatments/asthama';
// import Eczema from './components/screens/Treatments/Skintreatment/eczema';
//  import Psoriasis from './components/screens/Treatments/Skintreatment/psoriasis';
import Advancedhair from "././components/screens/AdvancedTreatmentsforHome/advancedhair";
// import Migraine from './components/screens/Treatments/Neurologicaltreatments/migraine';
import DiseaseDetails from "./components/screens/Treatments/disease";
import Hairprp from "./components/screens/AdvancedTreatmentsforHome/hairprp";
import Hair from "./components/screens/AdvancedTreatmentsforHome/stmhair";
import GfcHair from "./components/screens/AdvancedTreatmentsforHome/gfchair";
import Laserhair from "./components/screens/AdvancedTreatmentsforHome/laserhair";
import AdvancedSkin from "./components/screens/AdvancedSkin/hydrafacial";
import Acne from "./components/screens/AdvancedSkin/acne";
import Skinbrightening from "./components/screens/AdvancedSkin/skinbrightening";
import Antiageing from "./components/screens/AdvancedSkin/antiageing";
import Youth from "./components/screens/AdvancedSkin/youth";
import Prpface from "./components/screens/AdvancedSkin/prpface";
import CO2Facial from "./components/screens/AdvancedSkin/co2";

import Acnescar from "./components/screens/AdvancedSkin/acnescar";
import Molebirth from "./components/screens/AdvancedSkin/mole&birth";
import Tattoremoval from "./components/screens/AdvancedSkin/tattoremoval";
import Wartsremoval from "./components/screens/AdvancedSkin/wartsremoval";
import Antiageinglaser from "./components/screens/AdvancedSkin/antiageinglaser";
import Laserhairremoval from "./components/screens/AdvancedSkin/laserhairremoval";
import Dental from "./components/screens/Dental/Dental";
// In your router configuration file
import JayanagarDental from "./components/screens/Dental/clinics/jayanagar/JayanagarDental";
import GirukambakkamDental from "./components/screens/Dental/clinics/girukambakkam/GirukambakkamDental";
import ValasaravakamDental from "./components/screens/Dental/clinics/valasaravakam/ValasaravakamDental";
import BlogHome from "./components/screens/Blog/BlogHome";
import DentalBlog from "./components/screens/Blog/Articles/DentalBlog/DentalBlog";
import PrpBlog from "./components/screens/Blog/Articles/PrpBlog/PrpBlog";
import Gfcblog from "./components/screens/Blog/Articles/Gfcblog/Gfcblog";
import Thankyou from "./components/Thankyou/Thankyou";
import Growhair from "./components/screens/Blog/Articles/GrowHair/Growhair";
import Glowingskin from "./components/screens/Blog/Articles/GlowingSkin/Glowingskin";
import Alltreatments from "./components/screens/Treatment/Alltreatments";
import VeenaDoc from "./components/screens/Doctors/VeenaDoc/VeenaDoc";
import ChayanikaDoc from "./components/screens/Doctors/ChayanikaDoc/ChayanikaDoc";
import SpoorthiDoc from "./components/screens/Doctors/SpoorthiDoc/SpoorthiDoc";
import YuvapriyaDoc from "./components/screens/Doctors/YuvapriyaDoc/YuvapriyaDoc";
import YuganthiDoc from "./components/screens/Doctors/YuganthiDoc/YuganthiDoc";
import AshwiniDoc from "./components/screens/Doctors/AshwiniDoc/AshwiniDoc";
import AhilanDoc from "./components/screens/Doctors/AhilanDoc/AhilanDoc";
import PargaviDoc from "./components/screens/Doctors/PargaviDoc/PargaviDoc";
import MuthumariDoc from "./components/screens/Doctors/MuthumariDoc/MuthumariDoc";
import PavithraDoc from "./components/screens/Doctors/PavithraDoc/PavithraDoc";
import RenukaDoc from "./components/screens/Doctors/RenukaDoc/RenukaDoc";
import HydrafacialBlog from "./components/screens/Blog/Articles/HydrafacialBlog/HydrafacialBlog";
import GfcVsPrpBlog from "./components/screens/Blog/Articles/GfcVsPrp/GfcVsPrpBlog";
import StmHairBlog from "./components/screens/Blog/Articles/StmHairBlog/StmHairBlog";
import GfcHairGrowth from "./components/screens/Blog/Articles/GfchairgrowthBlog/GfcHairGrowth";
import BangaloreGfc from "./components/screens/Blog/Articles/BangaloreGfc/BangaloreGfc";

import HairTreatmentLanding from "./components/screens/HairTreatmentLanding/HairTreatmentLanding";
import BalajiDoc from "./components/screens/Doctors/BalajiDoc/BalajiDoc";
import UmaBarathiDoc from "./components/screens/Doctors/UmaBarathiDoc/UmaBarathiDoc";
import DharshanDoc from "./components/screens/Doctors/DharshanDoc/DharshanDoc";
import SabarmathyDoc from "./components/screens/Doctors/SabarmathyDoc/SabarmathyDoc";
import ChennaiGfc from "./components/screens/Blog/Articles/ChennaiGfc/ChennaiGfc";
import NelofarDoc from "./components/screens/Doctors/NelofarDoc/NelofarDoc";
import PrpBlog2025 from "./components/screens/Blog/PrpBlog2025/PrpBlog2025";
import SharmilaDoc from "./components/screens/Doctors/SharmilaDoc/SharmilaDoc";
import IndhumathiDoc from "./components/screens/Doctors/IndhumathiDoc/IndhumathiDoc";

// ...and so on for all your articles
// ScrollToTop Component (Integrated directly here)
// ScrollToTop Component (Smooth Scroll)

function Navigation() {
  return (
    <Router>
      <div className="main1">
        {/* Scroll to top after navigation */}
        <ScrollToTop />
        {/* Header Section - included at the top of every page */}
        <Header />
        {/* Small line between header and main content */}
        <div className="header-line"></div>
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bookconsultation" element={<BookConsultation />} />
            <Route path="/contact-us/" element={<ContactUs />} />
            <Route path="/login" element={<Loginhcura />} />
            <Route path="/about/" element={<Aboutus />} />
            <Route
              path="/homeopathy-online-consultation/"
              element={<Online />}
            />
            <Route
              path="/homeopathy-corporate-camps/"
              element={<Corporates />}
            />
            <Route path="/doctors-list/" element={<Doctors />} />
            <Route
              path="/homeopathy-best-treatments/"
              element={<Treatments />}
            />
            {/* <Route path="/skintreatments" element={<SkinTreatment />} /> */}
            <Route
              path="/homeopathy-clinic-in-bangalore/"
              element={<Bangalore />}
            />
            <Route
              path="/homeopathy-clinic-in-jayanagar-bangalore/"
              element={<Bangalorejay />}
            />
            <Route
              path="/multispecialty-clinic-in-chennai/"
              element={<Chennai />}
            />
            <Route
              path="/multispecialty-clinic-in-gerugambakkam-chennai/"
              element={<ChennaiMadh />}
            />
            <Route
              path="/multispecialty-clinic-in-valasaravakkam-chennai"
              element={<ChennaiVal />}
            />
            <Route
              path="/multispecialty-clinic-in-tambaram-chennai"
              element={<TambaramClinic />}
            />
            <Route
              path="/multispecialty-clinic-in-navalur-chennai"
              element={<HCuraNavalur />}
            />
            <Route
              path="/multispecialty-clinic-in-puducherry/"
              element={<PondyBranch />}
            />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/terms" element={<TermsConditions />} />
            {/* <Route path="/treatment/:diseaseName" element={<Skin1/>}/> */}
            {/* <Route path="/treatments/diabetes" element={<Diabetes/>}/> */}
            {/* <Route path="/treatments/asthma" element={<Asthma/>}/> */}
            {/* <Route path="/treatments/eczema" element={<Eczema/>} /> */}
            {/* <Route path="/treatments/psoriasis" element={<Psoriasis/>}/>  */}
            <Route
              path="/homeopathy-best-treatments/:name"
              element={<DiseaseDetails />}
            />
            <Route
              path="/advanced-grow-hair-treatment"
              element={<Advancedhair />}
            />
            <Route path="/advanced-hair-prp-treatment" element={<Hairprp />} />
            <Route path="/advanced-stm-treatment" element={<Hair />} />{" "}
            <Route path="/advanced-hair-gfc-treatment" element={<GfcHair />} />{" "}
            <Route path="/home/laser" element={<Laserhair />} />
            <Route path="/advanced-laser-treatment" element={<Laserhair />} />
            <Route
              path="/advanced-hydrafacial-treatment"
              element={<AdvancedSkin />}
            />
            <Route path="/advanced-acne-treatment" element={<Acne />} />
            <Route
              path="/advanced-skin-brightening-treatment"
              element={<Skinbrightening />}
            />
            <Route
              path="/advanced-anti-ageing-treatment"
              element={<Antiageing />}
            />
            <Route path="/advanced-youth-treatment" element={<Youth />} />
            <Route path="/advanced-prp-face-treatment" element={<Prpface />} />
            <Route
              path="/advanced-co2-facial-treatment"
              element={<CO2Facial />}
            />
            <Route
              path="/advanced-acne-scar-treatment"
              element={<Acnescar />}
            />{" "}
            <Route
              path="/advanced-mole-birth-mark-removal-treatment"
              element={<Molebirth />}
            />
            <Route
              path="/advanced-tatto-removal-treatment"
              element={<Tattoremoval />}
            />
            <Route
              path="/advanced-warts-removal-treatment"
              element={<Wartsremoval />}
            />{" "}
            <Route
              path="/advanced-anti-ageing-laser-treatment"
              element={<Antiageinglaser />}
            />
            <Route
              path="/advanced-laser-hair-removal-treatment"
              element={<Laserhairremoval />}
            />
            <Route path="/dental-treatment" element={<Dental />} />
            <Route
              path="/dental-treatment-in-bangalore/"
              element={<JayanagarDental />}
            />
            <Route
              path="/multispecialty-dental-clinic-in-gerugambakkam-chennai"
              element={<GirukambakkamDental />}
            />
            <Route
              path="/multispecialty-dental-clinic-in-valasaravakkam-chennai"
              element={<ValasaravakamDental />}
            />
            <Route path="/blog" element={<BlogHome />} />
            <Route
              path="/avoid-cavities-best-dental-clinic"
              element={<DentalBlog />}
            />
            <Route
              path="/prp-hair-growth-therapy-scalp-fertilizer"
              element={<PrpBlog />}
            />
            <Route
              path="/gfc-hair-treatment-vs-traditional-methods-bangalore-chennai"
              element={<Gfcblog />}
            />
            <Route path="/thankyou" element={<Thankyou />} />
            <Route
              path="/growhair-therapy-hair-fall-treatment"
              element={<Growhair />}
            />
            <Route path="/glowing-skin-treatment" element={<Glowingskin />} />
            <Route
              path="/gfc-vs-prp-hair-treatment"
              element={<GfcVsPrpBlog />}
            />
            <Route
              path="/how-many-gfc-sessions-for-hair-regrowth"
              element={<GfcHairGrowth />}
            />
            <Route
              path="/best-gfc-hair-regrowth-treatment-in-bangalore"
              element={<BangaloreGfc />}
            />
            <Route
              path="/stm-hair-treatment-for-hair-growth"
              element={<StmHairBlog />}
            />
            <Route
              path="/hydrafacial-dull-to-dazzling-restore-radiance"
              element={<HydrafacialBlog />}
            />
            <Route path="/alltreatments" element={<Alltreatments />} />
            <Route
              path="/hydrafacial-dull-to-dazzling-restore-radiance"
              element={<HydrafacialBlog />}
            />
            <Route path="/alltreatments" element={<Alltreatments />} />
            <Route
              path="/doctors/dr-veena-m-homeopathy-aesthetics-bangalore"
              element={<VeenaDoc />}
            />
            <Route
              path="/doctors/dr-chayanika-ghosh-dentist-jayanagar-bangalore"
              element={<ChayanikaDoc />}
            />
            <Route
              path="/doctors/dr-spoorthi-prasad-senior-homeopathy-doctor-jayanagar-bangalore"
              element={<SpoorthiDoc />}
            />
            <Route
              path="/doctors/dr-yuvapriya-p-dentist-aesthetic-jayanagar-bangalore"
              element={<YuvapriyaDoc />}
            />
            <Route
              path="/doctors/dr-yuganthi-durai-dentist-aesthetic-skin-hair-chennai"
              element={<YuganthiDoc />}
            />
            <Route
              path="/doctors/dr-ashwini-mr-homeopathy-cosmetic-doctor-valasaravakkam-chennai"
              element={<AshwiniDoc />}
            />
            <Route
              path="/doctors/dr-ahilan-murugadas-homeopathy-cosmetic-nutrition-gerugambakkam-chennai"
              element={<AhilanDoc />}
            />
            <Route
              path="/doctors/dr-j-pargavi-homeopathy-aesthetic-doctor-jayanagar-bangalore"
              element={<PargaviDoc />}
            />
            <Route
              path="/doctors/dr-muthumari-homeopathy-facial-aesthetics-valasaravakkam-chennai"
              element={<MuthumariDoc />}
            />
            <Route
              path="/doctors/dr-pavithrakamatchi-tambaram-chennai"
              element={<PavithraDoc />}
            />
            <Route
              path="/doctors/dr-renuka-e-best-homeopathy-doctor-jayanagar-bangalore"
              element={<RenukaDoc />}
            />
            <Route
              path="/doctors/dr-syed-nelofar-aesthetic-homoeopathy-bangalore"
              element={<NelofarDoc />}
            />
            <Route
              path="/hair-free-consultation"
              element={<HairTreatmentLanding />}
            />
            <Route
              path="/doctors/dr-krishnamoorthy-balaji"
              element={<BalajiDoc />}
            />
            <Route
              path="/doctors/dr-uma-barathi-homeopathy-aesthetic-chennai"
              element={<UmaBarathiDoc />}
            />
            <Route
              path="/doctors/dr-s-dharshan-homeopathy-chennai"
              element={<DharshanDoc />}
            />
            <Route
              path="/doctors/dr-sabarmathy-dentist-aesthetic-pondicherry"
              element={<SabarmathyDoc />}
            />
            <Route
              path="/doctors/dr-sharmila-bds-preventive-dentist-chennai"
              element={<SharmilaDoc />}
            />
         \
            <Route
              path="/doctors/dr-indhumathi-m-bhms-yoga-homeopathy-chennai"
              element={<IndhumathiDoc/>}
            />
            <Route
              path="/best-gfc-hair-regrowth-treatment-chennai"
              element={<ChennaiGfc />}
            />
            <Route
              path="/prp-hair-treatment-rapid-hair-regrowth-2025"
              element={<PrpBlog2025 />}
            />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default Navigation;
